/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Keys_New_TitleInputs */

const en_settings_keys_new_title = /** @type {(inputs: Settings_Keys_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your new key`)
};

const id_settings_keys_new_title = /** @type {(inputs: Settings_Keys_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key barumu`)
};

/**
* | output |
* | --- |
* | "Your new key" |
*
* @param {Settings_Keys_New_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_keys_new_title = /** @type {((inputs?: Settings_Keys_New_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Keys_New_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_keys_new_title(inputs)
	return en_settings_keys_new_title(inputs)
});